import React, { useEffect, useState } from 'react';  
import bellIconImg from 'images/icon/bell_icon-24x24.png';
import optionIcon from 'images/icon/option_icon-24x24.png';
import serverController from 'server/serverController';
import {
  TopInner,
  Title,
  Iconlist,
  BellIconLink,
  SetIconLink,
  Alarm,
  IconImg,
} from './style';

export default function MyPageHeader(props) {
  // 알림리스트 데이터 받아오기
  const [newAlarmExist, setNewAlarmExist] = useState(false);

  const unreadCheckCallback = (jsonData) => {
    if (jsonData.success !== 1) {
      alert('예기치 못한 문제가 발생하였습니다.');
      return;
    } else {
      if (jsonData['data'] && jsonData['data']['count']) {
        let unreadMsgCount = parseInt(jsonData['data']['count']);
        if (unreadMsgCount > 0) {
          setNewAlarmExist(true);
        } else {
          setNewAlarmExist(false);
        }
      } else {
        alert('예기치 못한 문제가 발생하였습니다.');
        return;
      }
    }
  };
  useEffect(() => {
    serverController.getServerData(`notifications/unread`, unreadCheckCallback);
  }, []);

  return (
    <TopInner style={{ borderBottom: props.borderbottom }}>
      <Title>{props.title}</Title>

      <Iconlist>
        <li>
          <BellIconLink to={`/mypage/setting/alarm`}>
            <IconImg src={bellIconImg} alt={'new notification exist'}/>
          </BellIconLink>
          {newAlarmExist ? <Alarm></Alarm> : null}
        </li>
        <li>
          <SetIconLink to={`/mypage/setting`}>
            <IconImg src={optionIcon} alt={'notification page link'}/>
          </SetIconLink>
        </li>
      </Iconlist>
    </TopInner>
  );
}
